import { render } from "./InternetMapping.vue?vue&type=template&id=460c988c&scoped=true"
import script from "./InternetMapping.vue?vue&type=script&lang=js"
export * from "./InternetMapping.vue?vue&type=script&lang=js"

import "./InternetMapping.vue?vue&type=style&index=0&id=460c988c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460c988c"]])

export default __exports__